import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";
import { ViewType } from "@supabase/auth-ui-shared";
import { useAuthRedirect } from "@/hooks/useAuthRedirect";
import { toast } from "sonner";

export default function AdminLogin() {
  const [loginType] = useState("admin");
  const [view, setView] = useState<ViewType>("sign_in");
  useAuthRedirect(loginType, () => {});

  const authConfig = {
    supabaseClient: supabase,
    appearance: {
      theme: ThemeSupa,
      style: {
        button: {
          background: "rgb(59 130 246)",
          color: "white",
          borderRadius: "0.5rem",
        },
        input: {
          borderRadius: "0.5rem",
        },
        message: {
          color: "red",
        },
      },
    },
    localization: {
      variables: {
        sign_in: {
          email_label: "Email Administrateur",
          password_label: "Mot de passe",
          email_input_placeholder: "Votre email",
          password_input_placeholder: "Votre mot de passe",
          button_label: "Connexion Administrateur",
        },
        forgotten_password: {
          button_label: "Mot de passe oublié ?",
          email_label: "Email",
          password_label: "Nouveau mot de passe",
          email_input_placeholder: "Votre email",
          loading_button_label: "Envoi en cours...",
          confirmation_text:
            "Vérifiez vos emails pour réinitialiser votre mot de passe",
        },
      },
    },
    providers: [],
    view: view,
    onError: (error: any) => {
      console.error("Auth error details:", error);
      
      if (error.message.includes("Invalid login credentials")) {
        toast.error("Email ou mot de passe incorrect. Veuillez réessayer.");
      } else if (error.message.includes("Email not confirmed")) {
        toast.error("Veuillez confirmer votre email avant de vous connecter");
      } else {
        toast.error("Une erreur est survenue lors de la connexion. Veuillez réessayer.");
      }
    },
  };

  return (
    <div className="flex min-h-screen">
      <div className="flex flex-1 flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div className="text-center mb-8">
            <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
              {view === "update_password" 
                ? "Réinitialisation du mot de passe" 
                : "Connexion Administrateur"}
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              {view === "update_password"
                ? "Définissez votre nouveau mot de passe"
                : "Accès réservé à l'administrateur"}
            </p>
          </div>
          <div className="mt-8">
            <Auth {...authConfig} />
          </div>
        </div>
      </div>
      <div className="relative hidden w-0 flex-1 lg:block">
        <img
          className="absolute inset-0 h-full w-full object-cover"
          src="/og-image.png"
          alt="Login background"
        />
      </div>
    </div>
  );
}